import React from 'react';

import { formatMoney } from '@betterment/core';
import { Icon, ListRow, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';
import { useColorMode } from '@betterment/shared-components/src/components/color-mode/ColorModeProvider';

import { ExternalAccountTransactionOptionLink } from './ExternalAccountTransactionOptionLink';
import { HomeExternalAccountsQuery } from './graphql/query.homeExternalAccounts.generated';

import { urlBuilder } from '../../Shared/urlBuilder';

type Props = { account: HomeExternalAccountsQuery['externalAccounts'][number] };

export const ExternalAccountRow: React.FC<Props> = ({ account }) => {
  const { colorMode } = useColorMode();

  return (
    <div className="group">
      <SambaAutoLink to={urlBuilder.appExternalAccounts.absolute()} css={{ _hover: { textDecoration: 'none' } }}>
        <ListRow css={{ py: 'space.300' }}>
          <ListRow.LeadingAsset css={{ width: '36px' }}>
            <img
              src={account.icon[colorMode]}
              alt={`${account.name} icon`}
              className={css({
                width: 'icon.medium',
                borderRadius: 'border.medium',
              })}
            />
          </ListRow.LeadingAsset>
          <ListRow.LeadingContent>
            <Text color="text" css={{ textDecoration: { _groupHover: 'underline', _groupFocus: 'underline' } }}>
              {account.name}
            </Text>
            <Text variant="text50" color="text.weak">
              {account.accountTypeAndRedactedAccountNumber}
            </Text>
          </ListRow.LeadingContent>
          <ListRow.TrailingAsset>
            <Icon name="CaretRight" size="small" color="icon" />
          </ListRow.TrailingAsset>
          <ListRow.TrailingContent>
            <Text variant="text50" color="text">
              {formatMoney(account.balance)}
            </Text>
            <Text variant="text50" color="text.weak">
              {account.lastUpdatedAtDisplay || undefined}
            </Text>
          </ListRow.TrailingContent>
          <ListRow.BottomContent>
            <ExternalAccountTransactionOptionLink account={account} />
          </ListRow.BottomContent>
        </ListRow>
      </SambaAutoLink>
    </div>
  );
};
